import create from "zustand";

const defaults = {
  template: {},
  sections: [],
  section: 0,
  cueAudioPlayed: [false, false, false],
  submitSectionDialog: false,
  currentQuestion: 0,
  partIndex: 0,
  part: null,
  attempt: null,
  uploadProgress: 0,
  referralCode: null,
  mockType: null,
  isRecording: false,
  isTimeout: false,
  startedAt: null,

  // Reading passage highlighter
  markerOn: false,
  highlights: {}, // { [passageId]: [{ start, end }] }

  //  For timer
  timeLeft: 0,
  totalTime: 0,
  playing: false,
  stopped: false,
};

const useStore = create((set, get) => ({
  ...defaults,
  setTemplate: (template) => set({ template }),
  setStartedAt: (startedAt) => set({ startedAt }),
  setQuestions: (questions) => set({ questions }),
  setSection: (section) => set({ section }),
  setCueAudioPlayed: (cueAudioPlayed) => set({ cueAudioPlayed }),
  nextSection: () => set((state) => {
    const totalSections = state.sections.length;

    if ((state.section + 1) === totalSections) state.endTest();

    return {
      section: Math.min(state.section + 1, totalSections), submitSectionDialog: false,
      currentQuestion: 0,
    };
  }),
  setMock: (mock) => set({
    mockType: mock.mockType,
    sections: mock.sections,
    totalTime: mock.duration,
    section: mock?.completedSections ? mock.completedSections.length : 0,
  }),
  setRecording: (isRecording) => set({ isRecording }),
  setReferralCode: (referralCode) => set({ referralCode }),
  setCurrentQuestion: (currentQuestion) => set({ currentQuestion }),
  setPartIndex: (partIndex) => set({ partIndex }),
  openSubmitSectionDialog: () => set({ submitSectionDialog: true }),
  closeSubmitSectionDialog: () => set({ submitSectionDialog: false }),
  setAttempt: (attempt) => set({ attempt }),
  setQuestionResults: (questionResults) => set({ questionResults }),
  setIsTimeout: (isTimeout) => set({ isTimeout }),

  // Reading passage highlighter
  toggleMarker: () => set((state) => ({ markerOn: !state.markerOn })),
  setPassageHighlights: (passageId, list) => set((state) => ({
    highlights: { ...state.highlights, [passageId]: list },
  })),

  // For timer
  setTotalTime: (totalTime) => set({ totalTime }),
  setTimeLeft: (timeLeft) => set({ timeLeft }),
  start: (totalTime) => set({
    timeLeft: totalTime,
    totalTime,
    isTimeout: false,
    playing: true,
    stopped: false,
  }),
  pause: () => set({ playing: false }),
  resume: () => set({ playing: true }),
  stop: () => set({ stopped: true }),

  prev: () => set(state => {
    const currQuestion = state.currentQuestion;
    const questions = state.sections[state.section].questions;

    const newQuestion = Math.max(currQuestion - 1, 0);

    return {
      currentQuestion: newQuestion,
      partIndex: questions[newQuestion].part,
    }
  }),
  next: () => set(state => {
    const currQuestion = state.currentQuestion;
    const questions = state.sections[state.section].questions;

    const newQuestion = Math.min(
      currQuestion + 1, questions.length - 1
    );
    return {
      currentQuestion: newQuestion,
      partIndex: questions[newQuestion].part,
    }
  }),
  initTest: ({ attempt }) => set({ attempt }),
  endTest: () => { },
  reset: () => set(defaults),
}),
);

export default useStore;